import { ExternalLink, Wrench } from 'lucide-react';
import { AppLayout } from '@/components/Layout/AppLayout';

// ─── Die Verwaltung ist umgezogen ───────────────────────────────────────────
//
// Steht an der Stelle aller alten /admin-Adressen. Ein stilles 404 wäre hier
// die schlechtere Antwort: wer ein Lesezeichen auf die Benutzerverwaltung
// hat, soll erfahren, wohin sie gegangen ist – und nicht glauben, sie sei
// weg.
//
// Die Adresse der Konsole steht in VITE_ADMIN_URL. Ist sie nicht gesetzt,
// nennen wir sie nicht: eine geratene Adresse wäre schlimmer als keine.

const ADMIN_URL = import.meta.env.VITE_ADMIN_URL as string | undefined;

export function VerwaltungUmgezogenPage() {
  return (
    <AppLayout>
      <div className="mx-auto max-w-lg px-4 py-12 sm:px-6">
        <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-slate-100">
              <Wrench className="h-5 w-5 text-slate-500" aria-hidden="true" />
            </div>
            <div className="min-w-0">
              <h1 className="text-lg font-semibold text-slate-900">
                Die Verwaltung ist umgezogen
              </h1>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">
                Sicherungen, Konten, E-Mail, Sitzungen, Speicher und
                Wartungsmodus liegen jetzt in der Betreiberkonsole – einer
                eigenen Anwendung mit eigener Anmeldung. Der Stammbaum selbst
                bleibt hier.
              </p>

              {ADMIN_URL ? (
                <a
                  href={ADMIN_URL}
                  className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3.5 py-2 text-sm font-medium text-white hover:bg-blue-700"
                >
                  Zur Betreiberkonsole
                  <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
                </a>
              ) : (
                <p className="mt-4 rounded-lg bg-slate-50 p-3 text-xs leading-relaxed text-slate-500">
                  Die Adresse der Konsole ist in dieser Installation nicht
                  hinterlegt. Wer sie betreibt, weiß, wo sie liegt.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}

export default VerwaltungUmgezogenPage;
